import { useTranslation } from '../hooks/useTranslation';

const DEFAULT_MESSAGE_KEY = 'payment_method.wallet_unavailable';

export default function WalletUnavailableNotice({ providerName, messageKey, iconUrl }) {
  const { t } = useTranslation();
  const message = t(messageKey || DEFAULT_MESSAGE_KEY);

  return (
    <div className="wallet-notice" role="status" aria-live="polite">
      <div className="wallet-notice-card">
        {iconUrl && (
          <img className="wallet-notice-icon" src={iconUrl} alt="" aria-hidden="true" />
        )}
        {providerName && <div className="wallet-notice-provider">{providerName}</div>}
        <div className="wallet-notice-message">{message}</div>
      </div>
    </div>
  );
}
